export function executeWithTime(method, name) {
  console.time(name); //eslint-disable-line no-console
  let result = method();
  console.timeEnd(name); //eslint-disable-line no-console
  return result;
}
